import axios from 'axios';
import jwtDecode from 'jwt-decode';
import tokenService from '../services/token-service';

export const TOKEN_KEY = 'token';

export interface TokenBody {
  _id: string;
  access: string;
  email: string | null;
  name: string;
  parent: string | null;
  phoneNumber: string;
  username: string;
  throwawayFlag: boolean;
}

export const setJwt = (token: string) => {
  window.localStorage.setItem(TOKEN_KEY, token);
};

export const removeJwt = () => {
  window.localStorage.removeItem(TOKEN_KEY);
}

export const getJwt = () => {
  return window.localStorage.getItem(TOKEN_KEY);
};

export const getCurrentUser = (): TokenBody => {
  try {
    const { user } = jwtDecode(getJwt()) as any;
    return user;
  }
  catch (e) {
    return null;
  }
}

export const verify = async () => {
  const response = await tokenService.verify();
  return response;
}

export const resetToken = () => {
  axios.defaults.headers.common['x-access-token'] = getJwt();
}

export default {
  setJwt: setJwt,
  getJwt: getJwt,
  getCurrentUser: getCurrentUser,
  removeJwt: removeJwt,
  verify: verify
}
